/* eslint-disable no-console */

const isTestingEnvironment = () => {
    try {
        // if page is loaded in an iframe, accessing properties in parent window will fail due to origin policies
        console.log(window.top.location.href);
    } catch (e) {
        return false;
    }
    return true;
};

export default isTestingEnvironment;
